import { getTenantHost } from "./tenant";

const userStorageKey = () => {
  const host = getTenantHost() || "default";
  return `user:${host}`;
};

export const getStoredUser = () => {
  const scopedKey = userStorageKey();
  const scoped = localStorage.getItem(scopedKey);
  if (scoped) {
    try {
      return JSON.parse(scoped);
    } catch {
      localStorage.removeItem(scopedKey);
    }
  }

  // Migrasi sesi lama (key global "user") ke key per-tenant
  const legacy = localStorage.getItem("user");
  if (legacy) {
    try {
      const parsed = JSON.parse(legacy);
      localStorage.setItem(scopedKey, legacy);
      localStorage.removeItem("user");
      return parsed;
    } catch {
      localStorage.removeItem("user");
    }
  }

  return null;
};

export const setStoredUser = (user) => {
  localStorage.setItem(userStorageKey(), JSON.stringify(user));
  localStorage.removeItem("user");
};

export const removeStoredUser = () => {
  localStorage.removeItem(userStorageKey());
  localStorage.removeItem("user");
};
